export enum Api { Hub = process.env.VUE_APP_HUB_API_URI, DialPlanService = process.env.VUE_APP_DIALPLAN_API_URI }

// Generic form API response, prevents the need for strongly typed responses
export type JsonData = { [k: string]: string | number | boolean | JsonData | JsonData[] | null | undefined }

export enum RequestMethod { GET = 'GET', POST = 'POST', PUT = 'PUT', PATCH = 'PATCH', DELETE = 'DELETE' }
